<div class="w-full h-full flex flex-col py-6 px-6">
  <!-- Options bar -->
  <div class="flex-0 mb-1 flex justify-end dark:text-gray-300 text-sm">
    <!-- IT-F2-407: split-button on Add User — main click opens the
         single-add drawer; chevron drops down a menu with Bulk Add. -->
    <div class="relative ml-2 inline-flex">
      <button type="button" class="dark-btn rounded-r-none border-r-0" (click)="on_add_user_click()">
        <i class="fa-solid fa-fw fa-user mr-1 dark:text-blue-400"></i> Add User
      </button>
      <button type="button" class="dark-btn rounded-l-none px-2"
              (click)="openBulkAddMenu($event)"
              title="More add options">
        <i class="fa-solid fa-caret-down text-xs opacity-70"></i>
      </button>
      <ng-container *ngIf="add_user_menu_open">
        <div class="fixed inset-0 z-0" (click)="add_user_menu_open = false"></div>
        <div class="absolute right-0 top-full z-10 mt-1 min-w-[220px] rounded border border-gray-200 dark:border-[#434863] bg-white dark:bg-app-black-100 shadow-lg py-1 text-sm">
          <button type="button"
                  class="w-full text-left px-3 py-2 flex items-center gap-2 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-app-blue-100/30 transition"
                  (click)="openBulkAddModal()"
                  title="Bulk-add users by pasting a list of emails.">
            <i class="fa-solid fa-fw fa-users text-app-teal-100"></i>
            <span>Bulk Add Users</span>
          </button>
        </div>
      </ng-container>
    </div>
    <button type="button" class="ml-2 dark-btn" (click)="on_import_users_click()">
      <i class="fa-solid fa-fw fa-file-csv mr-1 dark:text-blue-400"></i> Import Users
      <input #usersFileImport type="file" accept=".csv" (change)="processImportUsers($event)" class="hidden">
    </button>
    <!-- <button type="button" class="ml-2 dark-btn" [class.dark-btn-disabled]="!selected_user" [disabled]="!selected_user" (click)="reset_user_password(selected_user)">
      <i class="fa-solid fa-fw fa-key mr-1 dark:text-blue-300"></i> Reset Password
    </button> -->
    <button type="button" class="ml-2 dark-btn"
            [class.dark-btn-disabled]="!selected_user"
            [disabled]="!selected_user"
            (click)="open_impersonate(selected_user)"
            [title]="selected_user ? 'Open a new tab signed in as this user (impersonation banner shown in the destination SPA)' : 'Select a user first'">
      <i class="fa-solid fa-fw fa-user-secret mr-1 dark:text-fuchsia-400"></i> View as User
    </button>
    <button type="button" class="ml-2 dark-btn" [class.dark-btn-disabled]="!selected_user" [disabled]="!selected_user" (click)="on_sync_user_click()">
      <i class="fa-solid fa-fw fa-sync mr-1 dark:text-blue-500"></i> SYNC User
    </button>
    <!-- Actions dropdown — groups selection-driven actions (Override Password
         + Send Welcome Email) that previously lived as top-level buttons.
         Both entry points open the same override-password modal, one
         pre-selecting the password-set flow, the other the magic-link
         welcome-email flow. Mike 2026-07-17. -->
    <div class="relative ml-2">
      <button type="button" class="dark-btn"
              [class.dark-btn-disabled]="selected_users_for_password.length === 0"
              [disabled]="selected_users_for_password.length === 0"
              (click)="actions_open = !actions_open; $event.stopPropagation()"
              [title]="selected_users_for_password.length === 0 ? 'Tick at least one row' : 'Bulk actions for the ' + selected_users_for_password.length + ' selected user(s)'">
        <i class="fa-solid fa-fw fa-bolt mr-1 dark:text-amber-400"></i> Actions
        <span *ngIf="selected_users_for_password.length > 0" class="ml-1 text-xs opacity-80">({{ selected_users_for_password.length }})</span>
        <i class="fa-solid fa-caret-down ml-1 text-xs opacity-70"></i>
      </button>
      <ng-container *ngIf="actions_open">
        <!-- Full-viewport transparent backdrop closes the menu on any
             outside click. z-0 sits behind the menu panel itself. -->
        <div class="fixed inset-0 z-0" (click)="actions_open = false"></div>
        <div class="absolute right-0 z-10 mt-1 min-w-[220px] rounded border border-gray-200 dark:border-[#434863] bg-white dark:bg-app-black-100 shadow-lg py-1 text-sm">
          <button type="button"
                  class="w-full text-left px-3 py-2 flex items-center gap-2 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-app-blue-100/30 transition"
                  (click)="open_override_password('password'); actions_open = false"
                  title="Set a new password for the selected user(s) — AWS AdminSetUserPassword, no email sent.">
            <i class="fa-solid fa-fw fa-key text-amber-400"></i>
            <span>Override Password</span>
          </button>
          <button type="button"
                  class="w-full text-left px-3 py-2 flex items-center gap-2 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-app-blue-100/30 transition"
                  (click)="openWelcomeEmailModal(); actions_open = false"
                  title="Preview + send a branded welcome email — magic-link (A) for new / FORCE_CHANGE_PASSWORD users, branded activation (B) for existing.">
            <i class="fa-solid fa-fw fa-envelope-circle-check text-app-teal-100"></i>
            <span>Send Welcome Email</span>
          </button>
        </div>
      </ng-container>
    </div>
    <button type="button" class="ml-2 dark-btn" [class.dark-btn-disabled]="!can_delete_user()" [disabled]="!can_delete_user()" (click)="on_delete_user_click()"
            [title]="delete_target_count() === 0 ? 'Tick at least one row (or click a row) -- you cannot delete yourself' : 'Delete ' + delete_target_count() + ' selected user(s)' + (is_super_admin_delete() ? '' : ' -- queues a request for super-admin review')">
      <i class="fa-solid fa-fw fa-trash mr-1 dark:text-red-500"></i>
      {{ is_super_admin_delete() ? 'Delete User' : 'Request Deletion' }}<span *ngIf="delete_target_count() > 0" class="ml-1 text-xs opacity-80">({{ delete_target_count() }})</span>
    </button>
    <button type="button" class="ml-2 dark-btn min-w-[125px]" (click)="clear_filters()">
      <i class="fa-solid fa-xmark mr-1 dark:text-green-600"></i> Clear Filters
    </button>
    <!-- Copy a shareable URL that reproduces the current filter + sort +
         external-email state. Paste target lands on the identical view.
         Mike 2026-07-06. -->
    <button type="button" class="ml-2 dark-btn"
            (click)="shareFilteredLink()"
            title="Copy a URL that reproduces the current filter, sort, and email-list state so a coworker can land on the same view.">
      <i class="fa-solid fa-fw fa-link mr-1 dark:text-sky-400"></i> Share Filter
    </button>
    <!-- Export currently-filtered-and-sorted rows to CSV. Skips
         checkboxes / renderer-only columns. Mike 2026-07-06. -->
    <button type="button" class="ml-2 dark-btn"
            (click)="exportFilteredCsv()"
            title="Download the currently-filtered rows as CSV (respects filters + sort + column visibility).">
      <i class="fa-solid fa-fw fa-file-arrow-down mr-1 dark:text-emerald-400"></i> Export CSV
    </button>
    <!-- IT-F2-428 (Mike 2026-09-25): customer-scoped reconciliation
         report popup. Different from Export CSV — the customer gets a
         snapshot they can reconcile against their purchase records
         (email / status / scanners / claims / created / last login /
         last updated) with no cross-customer data mixed in. -->
    <button type="button" class="ml-2 dark-btn"
            (click)="openReconciliationModal()"
            title="Per-customer user snapshot for reconciliation against their purchase records — no cross-customer data.">
      <i class="fa-solid fa-fw fa-user-check mr-1 dark:text-sky-400"></i> Reconciliation Report
    </button>
    <button type="button" class="ml-2 dark-btn" (click)="refresh()">
      <i class="fa-solid fa-fw fa-sync mr-1 dark:text-green-600"></i> Refresh
    </button>
    <button type="button" class="ml-2 dark-btn"
            [class.dark-btn-disabled]="syncState.state$.value.inProgress"
            [disabled]="syncState.state$.value.inProgress"
            [title]="syncState.state$.value.inProgress ? 'Refresh already in progress (started by ' + (syncState.state$.value.byEmail || 'unknown') + ')' : 'Force a full Cognito → Redis cache reconcile'"
            (click)="refresh_user_cache()">
      <i class="fa-solid fa-fw fa-rotate mr-1 dark:text-amber-400"
         [class.fa-spin]="syncState.state$.value.inProgress"></i>
      Refresh Cache
    </button>
  </div>

  <!-- Multi-email deep-link chip. Renders when the operator lands here
       from Commerce Events' "Look up N users in Users panel" right-click
       action (?emails=a,b,c). Dismissable — clearing revokes the external
       filter but leaves any column filters intact. Mike 2026-07-05. -->
  <div *ngIf="emailListFilter && emailListFilter.size > 0"
       class="flex-0 mb-2 flex items-center gap-2 rounded border border-app-teal-100/50 bg-app-teal-100/10 px-3 py-2 text-xs text-app-teal-100">
    <i class="fa-solid fa-filter text-app-teal-100"></i>
    <span class="font-semibold">Filtered to {{ emailListRaw.length }} email{{ emailListRaw.length === 1 ? '' : 's' }} from Commerce Events:</span>
    <span class="font-mono text-[11px] text-gray-300 truncate max-w-[60ch]" [title]="emailListRaw.join(', ')">
      {{ emailListRaw.slice(0, 3).join(', ') }}<span *ngIf="emailListRaw.length > 3"> · +{{ emailListRaw.length - 3 }} more</span>
    </span>
    <button type="button"
            class="ml-auto text-gray-300 hover:text-white uppercase tracking-wide"
            (click)="clearEmailListFilter()">
      <i class="fa-solid fa-xmark mr-1"></i>Clear
    </button>
  </div>

  <!-- Grid -->
  <div class="flex-1 w-full h-[600px] relative">
    <ag-grid-angular
      class="w-full h-full"
      [theme]="theme"
      [gridOptions]="grid.options"
      [columnDefs]="grid.columnDefs"
      [rowData]="data"
      [statusBar]="grid.statusBar"
      (gridReady)="on_grid_ready($event)"
      (firstDataRendered)="on_first_data_rendered($event)"
      (modelUpdated)="on_model_updated($event)"
      (rowSelected)="on_row_selected($event)"
    />
    <!-- Live toggle, bottom-right over the ag-grid status bar. Mirrors
         the visual style from /admin/error-reports' header Live pill
         (live-dot + uppercase label). Default ON; click flips state and
         opens/closes the EventSource. -->
    <button type="button"
            class="absolute bottom-1 right-2 z-10 text-[10px] uppercase tracking-wide border rounded px-2 py-0.5 transition inline-flex items-center gap-1.5 bg-white dark:bg-app-black-100"
            [class.text-app-teal-100]="liveOn"
            [class.border-app-teal-100]="liveOn"
            [class.text-gray-500]="!liveOn"
            [class.dark:text-gray-400]="!liveOn"
            [class.border-gray-300]="!liveOn"
            [class.dark:border-[#434863]]="!liveOn"
            (click)="toggleLive()"
            [title]="liveOn ? 'Live updates ON — grid reflects Cognito changes from anywhere in realtime' : 'Live updates OFF — click to resume realtime grid updates'">
      <span class="live-dot" [class.live-dot--on]="liveOn"></span>
      Live
    </button>
  </div>
</div>

<!-- IT-F2-407: Bulk Add Users paste modal. Small dialog with a single
     textarea for pasting emails (one per line, or comma/space/semicolon
     separated). Submit routes into the same CSV mapping wizard the
     Import Users file-upload path feeds, so the downstream customer +
     scanners + correlated-claims + dedup + branded-SES banner path
     is reused verbatim. -->
<div *ngIf="bulk_add_modal_open"
     class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
     (click)="closeBulkAddModal()">
  <div class="bg-white dark:bg-app-black-500 rounded shadow-lg max-w-xl w-full border border-gray-200 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="px-4 py-3 border-b border-gray-200 dark:border-[#434863] flex items-center justify-between">
      <h3 class="font-semibold text-gray-900 dark:text-white">
        <i class="fa-solid fa-users mr-2 text-app-teal-100"></i>Bulk Add Users
      </h3>
      <button type="button" class="text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white" (click)="closeBulkAddModal()">✕</button>
    </div>
    <div class="p-4 space-y-3 text-sm">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Paste one email per line or separate them with commas / spaces / semicolons.
        After you click <b>Next</b> you&rsquo;ll pick the customer + scanners + welcome-email
        preferences in the field-mapping wizard.
      </p>
      <!-- IT-F2-407 (Mike 2026-09-18 c/5efd73fa): Ctrl+Enter fires Next
           for the power-user paste-and-submit flow. -->
      <textarea class="w-full border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 text-gray-900 dark:text-white rounded px-2 py-2 font-mono text-xs min-h-[220px]"
                [(ngModel)]="bulk_add_emails_text"
                (keydown.control.enter)="submitBulkAddPasted()"
                (keydown.meta.enter)="submitBulkAddPasted()"
                placeholder="alice@example.com&#10;bob@example.com, carol@example.com&#10;&#10;(Ctrl+Enter or ⌘+Enter to submit)"></textarea>
    </div>
    <div class="px-4 py-3 border-t border-gray-200 dark:border-[#434863] flex justify-end gap-2">
      <button type="button" class="px-3 py-1 border border-gray-300 dark:border-[#434863] rounded hover:bg-gray-100 dark:hover:bg-app-blue-100/50 text-gray-900 dark:text-white" (click)="closeBulkAddModal()">Cancel</button>
      <button type="button" class="dark-btn-primary px-3 py-1" (click)="submitBulkAddPasted()" title="Ctrl+Enter">Next</button>
    </div>
  </div>
</div>

<!-- Add User drawer (IT-F2-106 Phase 1). Mirrors the tracker's right-
     slide drawer w/ Maximize2 expand toggle from f2-tracker/src/App.tsx
     Drawer (~L1463). Overlay is dismissible when NOT full-page; when
     full-page it occupies the viewport and hides the overlay + the
     border. Existing form contents below are untouched — Phases 2-5
     replace them with the per-scanner expander redesign. -->
<div *ngIf="showAddUserModal && !addUserFullPage"
     (click)="closeAddUserDrawer()"
     class="fixed inset-0 z-40 dark:bg-[rgba(0,0,0,0.5)]"></div>
<aside *ngIf="showAddUserModal"
       class="fixed top-0 right-0 bottom-0 z-50 flex flex-col
              bg-white dark:bg-app-black-100 shadow-2xl
              transition-[width] duration-150 ease-out"
       [class.border-l]="!addUserFullPage"
       [class.border-gray-300]="!addUserFullPage"
       [class.dark:border-app-black-300]="!addUserFullPage"
       [style.width]="addUserFullPage ? '100vw' : 'min(720px, 92vw)'">
  <!-- Header — title + Maximize/Minimize toggle + Close. Icons follow
       the tracker's Maximize2/Minimize2 (Font Awesome equivalents). -->
  <div class="flex items-center gap-2 px-4 py-3 border-b border-gray-200 dark:border-app-black-300 bg-gray-50 dark:bg-app-black-100">
    <i class="fa-solid fa-user text-strat_orange-100"></i>
    <h1 class="text-sm font-semibold text-gray-900 dark:text-white flex-1 truncate">Add User</h1>
    <button type="button"
            (click)="toggleAddUserFullPage()"
            [title]="addUserFullPage ? 'Collapse to side panel' : 'Open full page'"
            class="px-2 py-1 text-gray-500 hover:text-gray-900 dark:hover:text-white rounded transition">
      <i class="fa-solid" [class.fa-down-left-and-up-right-to-center]="addUserFullPage" [class.fa-up-right-and-down-left-from-center]="!addUserFullPage"></i>
    </button>
    <button type="button"
            (click)="closeAddUserDrawer()"
            title="Close"
            class="px-2 py-1 text-gray-500 hover:text-gray-900 dark:hover:text-white rounded transition">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <!-- Body — scrollable. Existing form content unchanged; Phases 2-5
       swap this out for the per-scanner expander redesign. When
       full-page, cap the form width + center so the form doesn't
       stretch edge-to-edge on wide monitors. -->
  <div class="flex-1 overflow-y-auto p-6 dark:bg-gradient-to-b from-app-black-200 to-app-black-300"
       [style.max-width]="addUserFullPage ? '560px' : null"
       [style.margin-left]="addUserFullPage ? 'auto' : null"
       [style.margin-right]="addUserFullPage ? 'auto' : null"
       [style.width]="addUserFullPage ? '100%' : null">
    <div class="hidden">
      <!-- Legacy header hidden — the drawer's own header is now the
           title bar. Kept for template-diff continuity; empty div is
           free at runtime. -->
    </div>
    <form class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300">
      <!-- IT-F2-407: First/Last name only marked required when admin sets an
           inline password. On the magic-link path the user fills their own
           name on the /accept-invite set-password page — asterisk hides too. -->
      <div>
        <label for="first_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          First Name<span *ngIf="!!newUser.password">*</span>
          <span *ngIf="!newUser.password" class="text-xs font-normal text-gray-500 dark:text-gray-400">(optional — user sets on first sign-in)</span>
        </label>
        <input name="first_name" autocomplete="off" [(ngModel)]="newUser.name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
      </div>
      <div class="mt-8">
        <label for="last_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Last Name<span *ngIf="!!newUser.password">*</span>
          <span *ngIf="!newUser.password" class="text-xs font-normal text-gray-500 dark:text-gray-400">(optional — user sets on first sign-in)</span>
        </label>
        <input name="last_name" autocomplete="off" [(ngModel)]="newUser.last_name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
      </div>
      <div class="mt-8">
        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email*</label>
        <input type="email" name="email" autocomplete="off"
               [(ngModel)]="newUser.email"
               (ngModelChange)="on_add_user_email_change()"
               (blur)="_run_add_email_lookup()"
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
        <p *ngIf="newUser.email && !is_valid_email(newUser.email)"
           class="mt-1 text-xs text-red-400">Must be a valid email address.</p>
        <p *ngIf="add_email_lookup_busy" class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Checking pools for this email…
        </p>
        <p *ngIf="!add_email_lookup_busy && add_email_existing_pool_ids.length > 0"
           class="mt-1 text-xs text-amber-500">
          <i class="fa-solid fa-triangle-exclamation mr-1"></i>
          Already exists in {{ add_email_existing_pool_ids.length }} pool(s) — those customers are disabled below.
        </p>
      </div>
      <div class="mt-8">
        <label for="role" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Role*</label>
        <select name="role" [(ngModel)]="newUser.role" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
          <option *ngFor="let role of roles" [value]="role">{{role}}</option>
        </select>
      </div>
      <!-- Customer picker grouped by Cognito pool (Mike 2026-07-01: "one user
           at a time to one Cognito pool"). Radio at the pool level; the sole
           picker on the modal. For the legacy shared pool, expand into
           per-slug checkboxes because multiple customers share one pool. For
           a dedicated pool (customer_owned_domain style — 1:1 with a
           customer), the sole slug is auto-selected as an implicit
           consequence of picking the pool — no redundant tick needed.
           Pools whose identity already carries newUser.email are disabled
           so we can't create a duplicate. -->
      <div class="mt-8" *ngIf="newUser.role && newUser.role != 'admin'">
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Cognito pool*</label>
        <!-- Scoped roles (client / client_admin) see only pools that
             hold customers on their own custom:customers list — see
             add_pool_groups. When the resulting list is empty we
             surface a helpful note instead of an empty picker that
             leaves the operator staring at whitespace with the submit
             button disabled. ER-ASWJRE9 2026-07-02. -->
        <div *ngIf="add_pool_groups.length === 0"
             class="text-xs italic text-gray-500 dark:text-gray-400 border border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
          <i class="fa-solid fa-circle-info mr-1"></i>
          No customers in your scope. Ask a super-admin to add you to
          the customer you want to create users for, or create the
          user via the customer's own admin console.
        </div>
        <div *ngIf="add_pool_groups.length > 0"
             class="bg-gray-50 dark:bg-gray-700 dark:border-gray-600 border border-gray-300 rounded-md p-2 max-h-64 overflow-y-auto">
          <div *ngFor="let g of add_pool_groups; trackBy: trackByPoolId" class="mb-3 last:mb-0">
            <div class="flex items-center py-0.5"
                 [title]="g.taken
                   ? 'User ' + (newUser.email || '') + ' already exists in this pool — cannot create a duplicate identity.'
                   : ''">
              <input [id]="'add-pool-' + (g.pool_id || 'legacy')" type="radio" name="add-pool"
                [checked]="add_selected_pool_id === g.pool_id"
                [disabled]="g.taken"
                (change)="on_add_pool_change(g)"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 disabled:opacity-50">
              <label [for]="'add-pool-' + (g.pool_id || 'legacy')"
                     class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                     [class.opacity-50]="g.taken">
                {{g.label}}
                <span *ngIf="g.taken"
                      class="ml-1 text-[10px] text-amber-500 uppercase tracking-wide">
                  already in pool
                </span>
              </label>
            </div>
            <!-- Slug checkboxes inside the legacy pool group. Only visible
                 when the legacy radio is selected; multiple ticks allowed. -->
            <div *ngIf="g.is_legacy && add_selected_pool_id === g.pool_id"
                 class="ml-6 mt-1 border-l border-gray-300 dark:border-gray-600 pl-3">
              <div *ngFor="let slug of g.slugs; trackBy: trackByString" class="flex items-center py-0.5">
                <input [id]="'add-slug-' + slug" type="checkbox"
                  [checked]="selected_add_customers.includes(slug)"
                  (change)="on_add_customer_change(slug, $event)"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm">
                <label [for]="'add-slug-' + slug"
                       class="ms-2 text-sm text-gray-900 dark:text-gray-300">{{slug}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Scanner picker grouped by selected customer, with an "All" wildcard per group. -->
      <div class="mt-8" *ngIf="newUser.role && newUser.role != 'admin'">
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Scanners*</label>
        <div *ngIf="selected_add_customers.length === 0" class="text-xs italic text-gray-500 dark:text-gray-400">
          Pick at least one customer first.
        </div>
        <div *ngIf="selected_add_customers.length > 0" class="bg-gray-50 dark:bg-gray-700 dark:border-gray-600 border border-gray-300 rounded-md p-2">
          <div *ngFor="let g of add_customer_scanner_groups; trackBy: trackByCustomer" class="mb-3">
            <div class="text-xs font-semibold text-gray-700 dark:text-gray-200 uppercase tracking-wide mb-1">{{g.customer}}</div>
            <div class="flex items-center py-0.5 pl-1">
              <input [id]="'add-all-' + g.customer" type="checkbox"
                [checked]="is_add_all_scanners_checked(g)"
                (change)="on_add_all_scanners_change(g, $event)"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm">
              <label [for]="'add-all-' + g.customer" class="ms-2 text-sm font-medium text-app-teal-100">All {{g.wildcard}} scanners</label>
            </div>
            <!-- IT-F2-106 Phase 3a: each scanner row is an accordion.
                 Checkbox enables the scanner; if it has channels[], a
                 sub-panel folds open right underneath with the picks.
                 Retires the standalone Channels (per-scanner) row that
                 used to sit below with a modal launcher. -->
            <div *ngFor="let s of g.scanners; trackBy: trackByScannerId">
              <div class="flex items-center py-0.5 pl-5">
                <input [id]="'add-scanner-' + s.Id" type="checkbox"
                  [checked]="is_add_scanner_checked(s.Id, g)"
                  [disabled]="is_add_scanner_disabled(g)"
                  (change)="on_add_scanner_change(s.Id, $event)"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm disabled:opacity-50">
                <label [for]="'add-scanner-' + s.Id" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300" [class.opacity-50]="is_add_scanner_disabled(g)">{{s.Name}} <span class="text-xs text-gray-500">({{s.Id}})</span></label>
              </div>
              <!-- Inline Claims sub-panel (IT-F2-106 Phase 3d) —
                   dedicated <app-inline-scanner-claims> component that
                   renders schema-driven fields using plain [value]/
                   (change) handlers (no Angular Forms / ngModel).
                   Sidesteps the freeze mechanism from Phase 3b's
                   flat-mode embed of the shared claims-editor. Data-
                   agnostic: schema comes from scanner.claims_schema
                   (or Customer.claims_schema fallback) and drives
                   every field renderer. -->
              <div *ngIf="is_add_scanner_checked(s.Id, g) && addUserScannerHasClaims(s.Id)"
                   class="ml-8 mb-2 border border-gray-200 dark:border-app-black-100 rounded bg-white dark:bg-app-black-100">
                <div class="flex items-center gap-2 px-3 py-1.5 border-b border-gray-100 dark:border-app-black-300">
                  <i class="fa-solid fa-key text-app-teal-100 text-xs"></i>
                  <span class="text-xs font-semibold text-gray-800 dark:text-gray-100">Claims</span>
                </div>
                <div class="p-3">
                  <app-inline-scanner-claims
                    [scanner]="_getScannerDocForTemplate(s.Id)"
                    [customer]="customerForScanner(s.Id)"
                    [entry]="entryForScanner(s.Id)"
                    (entryChange)="onInlineClaimsEntryChange(s.Id, $event)">
                  </app-inline-scanner-claims>
                </div>
              </div>

              <!-- Inline Channels sub-panel — renders only when the
                   scanner is enabled AND declares channels[]. Auto-
                   expands on enable; chevron toggles collapse/expand
                   without unchecking the scanner. -->
              <div *ngIf="is_add_scanner_checked(s.Id, g) && addUserScannerChannels(s.Id).length > 0"
                   class="ml-8 mb-2 border border-gray-200 dark:border-app-black-100 rounded bg-white dark:bg-app-black-100">
                <div class="flex items-center justify-between px-3 py-1.5 cursor-pointer select-none border-b border-gray-100 dark:border-app-black-300"
                     (click)="toggleChannelsPanel(s.Id)">
                  <div class="flex items-center gap-2 min-w-0">
                    <i class="fa-solid fa-tower-broadcast text-app-teal-100 text-xs"></i>
                    <span class="text-xs font-semibold text-gray-800 dark:text-gray-100">Channels</span>
                    <span class="text-[10px] text-gray-500 dark:text-gray-400">
                      {{ channelsPickedCountForScanner(s.Id) }} / {{ addUserScannerChannels(s.Id).length }}
                    </span>
                  </div>
                  <i class="fa-solid text-xs text-gray-500 dark:text-gray-400"
                     [class.fa-chevron-down]="isChannelsPanelExpanded(s.Id)"
                     [class.fa-chevron-right]="!isChannelsPanelExpanded(s.Id)"></i>
                </div>
                <div *ngIf="isChannelsPanelExpanded(s.Id)" class="p-2">
                  <div class="flex items-center justify-end gap-2 mb-2">
                    <button type="button" (click)="selectAllChannelsForScanner(s.Id)"
                            class="text-[10px] uppercase tracking-wide text-app-teal-100 hover:text-app-teal-200">
                      Select all
                    </button>
                    <span class="text-[10px] text-gray-400">·</span>
                    <button type="button" (click)="clearChannelsForScanner(s.Id)"
                            class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 hover:text-gray-300">
                      Clear
                    </button>
                  </div>
                  <div class="grid grid-cols-1 gap-1">
                    <label *ngFor="let ch of addUserScannerChannels(s.Id)"
                           class="inline-flex items-start gap-2 text-xs text-gray-900 dark:text-white border border-gray-200 dark:border-[#434863] rounded px-2 py-1 cursor-pointer hover:border-app-teal-100">
                      <input type="checkbox"
                             [checked]="isChannelPicked(s.Id, ch.id)"
                             (change)="toggleChannelPick(s.Id, ch.id)"
                             class="mt-0.5 cursor-pointer flex-shrink-0" />
                      <div class="flex flex-col min-w-0">
                        <span class="truncate font-medium">{{ ch.title }}</span>
                        <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
                          {{ ch.id }}<span *ngIf="ch.slug"> • {{ ch.slug }}</span>
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Per-scanner Claims + Channels for the users being created.
           Text inputs are DISABLED — the "Edit" button opens the shared
           claims-editor / channels-editor components (same UX the edit-
           user flow uses). The stored JSON is applied post-create via
           updateUserAttributes on every pool the user landed in. Placed
           BELOW the Scanners section so the operator picks scanners
           first, then refines per-scanner claims/channels.
           Rows only render when AT LEAST ONE of the picked scanners
           has the corresponding schema — a scanner without
           claims_schema hides the Claims row entirely, and a scanner
           without channels[] hides the Channels row. Mike 2026-07-02:
           "channels should remain hidden because as-os doesn't have
           any channels settings". -->
      <!-- Standalone Channels + Claims rows REMOVED — IT-F2-106
           Phase 3a moved channels inline under each enabled scanner
           row. Phase 3c moved Claims to a per-scanner Edit-modal
           button inside each scanner accordion row (see above). -->

      <!-- Magic-link toggle (Workstream A follow-up). When ON (default),
           the backend creates the user with SUPPRESS and sends a
           branded "Welcome — set your password" email via the pool's
           SES identity, with a one-time link to /accept-invite.
           When OFF, falls back to the legacy temp-password-via-Cognito-
           default-sender path.
           Hidden for the legacy pool (add_selected_pool_id === '')
           because legacy has no branded SES identity — the backend
           refuses to mint a magic-link there (would fall to Cognito
           default sender, phishing-flag), so we surface a small note
           instead of an unusable toggle. Mike / ER-6JQDRFJ 2026-07-01. -->
      <div *ngIf="add_selected_pool_id === ''"
           class="mt-6 p-3 rounded border border-amber-400/50 bg-amber-50 dark:bg-amber-900/20 text-[11px] text-amber-800 dark:text-amber-200">
        <i class="fa-solid fa-triangle-exclamation mr-1"></i>
        Legacy pool has no branded SES identity — Cognito will send a
        default "Your temporary password is …" email from
        no-reply&#64;verificationemail.com. Magic-link path is not
        available for this pool.
      </div>
      <div *ngIf="add_selected_pool_id !== '' && add_selected_pool_id !== null"
           class="mt-6 p-4 rounded border-2"
           [ngClass]="newUser.send_magic_link
             ? 'border-emerald-400 bg-emerald-50 dark:bg-emerald-900/20'
             : 'border-gray-300 dark:border-[#434863] bg-gray-50 dark:bg-app-black-100/40'">
        <label class="flex items-start gap-3 cursor-pointer">
          <input type="checkbox" [(ngModel)]="newUser.send_magic_link"
                 name="send_magic_link"
                 class="mt-1 w-5 h-5 text-emerald-600 bg-gray-100 border-gray-300 rounded-sm">
          <div class="flex-1">
            <div class="text-sm font-bold text-gray-900 dark:text-white flex items-center gap-2">
              <i class="fa-solid fa-envelope-circle-check"
                 [ngClass]="newUser.send_magic_link ? 'text-emerald-500' : 'text-gray-400'"></i>
              Send Welcome Email
            </div>
            <!-- Customer default hint. Blank while we're still fetching
                 or when there's no source slug (e.g. legacy-pool before
                 a customer is checked). -->
            <div *ngIf="add_user_customer_default_source_slug"
                 class="text-[11px] mt-1 text-gray-500 dark:text-gray-400">
              Default for
              <code class="text-app-teal-100">{{ add_user_customer_default_source_slug }}</code>:
              <span *ngIf="add_user_customer_default_welcome === true"
                    class="font-semibold text-emerald-600 dark:text-emerald-400">ON</span>
              <span *ngIf="add_user_customer_default_welcome === false"
                    class="font-semibold text-gray-500 dark:text-gray-400">OFF</span>
              <span *ngIf="add_user_customer_default_welcome === null"
                    class="italic text-gray-500 dark:text-gray-400">unknown</span>
              <span class="text-gray-500 dark:text-gray-400">
                (from <code class="font-mono">commerce_settings.welcome_email_enabled</code>)
              </span>
            </div>
            <!-- Big, unambiguous affirmation strip. Green when enabled,
                 muted when disabled — matches Mike's ask to make it
                 "very intentional and clear a welcome mail will be sent". -->
            <div *ngIf="newUser.send_magic_link"
                 class="mt-2 text-xs text-emerald-800 dark:text-emerald-200 flex items-start gap-2">
              <i class="fa-solid fa-check-circle mt-0.5"></i>
              <span>
                A branded welcome email <b>WILL</b> be sent to
                <code class="text-app-teal-100">{{ newUser.email || '&lt;email&gt;' }}</code>
                from the customer's SES identity — one-time "set your password"
                link, 7-day TTL. No temp password to hand off.
              </span>
            </div>
            <div *ngIf="!newUser.send_magic_link"
                 class="mt-2 text-xs text-gray-600 dark:text-gray-400 flex items-start gap-2">
              <i class="fa-solid fa-circle-xmark mt-0.5"></i>
              <span>
                <b>No welcome email</b> — Cognito sends its stock
                temp-password email from <code>no-reply&#64;verificationemail.com</code>
                and you'll need to communicate the temp password out-of-band.
              </span>
            </div>
          </div>
        </label>
      </div>

      <button type="submit" (click)="on_create_user()" [disabled]="!can_create_user()"
        class="mt-8 dark-btn-primary w-full" [class.dark-btn-disabled]="!can_create_user()">
        Save
      </button>
      <button (click)="closeAddUserDrawer()" class="dark-btn-secondary mt-1 w-full">
        Cancel
      </button>
    </form>
  </div>
</aside>

<!-- Delete User modal -->
<div *ngIf="showDeleteUserModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.8)]">
  <div class="flex-0 w-auto p-6 max-w-2xl">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-trash text-red-400 mr-2"></i>
      {{ is_super_admin_delete() ? 'Delete' : 'Request Deletion of' }} {{ delete_target_count() }} User{{ delete_target_count() === 1 ? '' : 's' }}
    </h1>
    <div class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300 dark:text-gray-200">
      <p *ngIf="is_super_admin_delete()">
        Permanently delete the following {{ delete_target_count() }} user(s) from Cognito? This cannot be undone.
      </p>
      <p *ngIf="!is_super_admin_delete()">
        Queue {{ delete_target_count() }} deletion request(s) for super-admin review?
      </p>
      <div class="my-4 max-h-64 overflow-y-auto border border-gray-300 dark:border-[#434863] rounded p-3 bg-gray-50 dark:bg-app-black-100/40">
        <div *ngFor="let u of delete_targets_preview()" class="py-1 text-sm flex items-center gap-1.5 flex-wrap">
          <!-- Email is the human-readable identity; Pool pill tells the
               admin WHICH Cognito identity is about to be deleted —
               same email can legitimately exist in N pools and the row
               picked from the grid is what we send to AWS. Matches the
               override-password modal's pattern. -->
          <span class="text-red-400 font-mono">{{ u.attributes?.email || u.username }}</span>
          <!-- IT-F2-421 (Mike 2026-09-23): split f2-dev-pool (legacy env pool)
               from f2-users-pool (F2's own pool) via pool_id. -->
          <span *ngIf="u.customer_slug === 'f2'" class="px-1.5 py-0.5 rounded text-[10px] font-mono"
                [class.bg-blue-900]="pool_label_for_row(u) === 'dev (legacy)'"
                [class.text-blue-200]="pool_label_for_row(u) === 'dev (legacy)'"
                [class.bg-purple-900]="pool_label_for_row(u) !== 'dev (legacy)'"
                [class.text-purple-200]="pool_label_for_row(u) !== 'dev (legacy)'">
            {{ pool_label_for_row(u) }}
          </span>
          <span *ngIf="u.customer_slug && u.customer_slug !== 'f2'" class="px-1.5 py-0.5 rounded text-[10px] bg-purple-900 text-purple-200">{{ u.customer_slug }}</span>
          <span *ngIf="u.attributes?.name || u.attributes?.family_name" class="ml-2 text-gray-400">
            {{ u.attributes?.name }} {{ u.attributes?.family_name }}
          </span>
        </div>
        <div *ngIf="delete_targets_overflow() > 0" class="py-1 text-xs italic text-gray-400">
          …and {{ delete_targets_overflow() }} more
        </div>
      </div>
      <button type="submit" (click)="delete_selected_users()" class="dark-btn-primary w-full mt-4">
        Yes — {{ is_super_admin_delete() ? 'Delete' : 'Request Deletion of' }} {{ delete_target_count() }}
      </button>
      <button (click)="showDeleteUserModal = false" class="dark-btn-secondary w-full mt-1">
        Cancel
      </button>
    </div>
  </div>
</div>


<!-- Legacy-pool copy-magic-link modal (post add-user).
     Pops after Add-User succeeds against the legacy pool. Legacy pool
     has no branded SES sender configured (ER-4533V6F), so the backend
     refused the automatic magic-link email. This modal lets the admin
     mint the URL manually and paste to the user out-of-band (email
     themselves, Slack, SMS). One row per created identity. -->
<div *ngIf="showLegacyMagicLinkModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.8)]">
  <div class="flex-0 w-auto p-6 max-w-2xl">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-link text-blue-300 mr-2"></i>
      Copy magic-link{{ pendingLegacyMagicLinks.length === 1 ? '' : 's' }} to send
    </h1>
    <div class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300 dark:text-gray-200">
      <p class="text-sm">
        {{ pendingLegacyMagicLinks.length }} user{{ pendingLegacyMagicLinks.length === 1 ? '' : 's' }} created in the
        <span class="px-1.5 py-0.5 rounded text-[10px] bg-blue-900 text-blue-200 font-mono">dev (legacy)</span>
        pool. Legacy has no branded SES sender configured, so no welcome email was sent — mint a magic-link URL below
        and send it to the user directly (email yourself, Slack, SMS). The link expires in 7 days.
      </p>
      <div class="my-4 max-h-80 overflow-y-auto border border-gray-300 dark:border-[#434863] rounded p-3 bg-gray-50 dark:bg-app-black-100/40 space-y-2">
        <div *ngFor="let entry of pendingLegacyMagicLinks" class="flex items-center gap-2 py-1">
          <div class="flex-1 min-w-0">
            <div class="text-sm font-mono text-gray-900 dark:text-white truncate">{{ entry.email }}</div>
            <div class="text-[11px] text-gray-500 dark:text-gray-400 truncate">{{ entry.pool_label }}</div>
          </div>
          <span *ngIf="entry.copied" class="text-[11px] text-green-500 dark:text-green-400 whitespace-nowrap">
            <i class="fa-solid fa-check mr-1"></i>Copied
          </span>
          <button type="button"
            class="dark-btn dark-btn-sm"
            (click)="copy_legacy_magic_link(entry)"
            [disabled]="entry.busy">
            <i class="fa-solid" [ngClass]="entry.busy ? 'fa-spinner fa-spin' : 'fa-clipboard'"></i>
            <span class="ml-1">{{ entry.copied ? 'Copy again' : 'Copy magic-link' }}</span>
          </button>
        </div>
      </div>
      <button (click)="close_legacy_magic_link_modal()" class="dark-btn-primary w-full mt-4">
        Done
      </button>
    </div>
  </div>
</div>


<!-- Edit Scanners modal -->
<div *ngIf="showEditUserScannersModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.8)]">
  <div class="flex-0 w-auto p-6 bg-white">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-clone text-app-teal-100 mr-2"></i> Scanners assignment
    </h1>
    <div class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300 dark:text-gray-200">
      <p>Select the scanners to assign for:</p>
      <h2 class="w-full text-center font-semibold text-app-teal-100">{{selected_user.attributes.name}} {{selected_user.attributes.family_name}}</h2>
      <!-- Scanners grouped by customer. Each group has an "All <prefix>* scanners"
           wildcard checkbox; when checked, individual scanner checkboxes for that
           group are disabled and shown as implicitly-selected. -->
      <div class="mt-4 max-h-[50vh] overflow-y-auto min-w-[320px]">
        <div *ngFor="let g of all_scanner_groups" class="mb-3">
          <div class="text-xs font-semibold text-gray-700 dark:text-gray-200 uppercase tracking-wide mb-1 px-1">{{g.customer}}</div>
          <div class="flex items-center py-0.5 pl-1">
            <input [id]="'edit-all-' + g.customer" type="checkbox"
              [checked]="is_edit_all_scanners_checked(g)"
              (change)="on_edit_all_scanners_change(g, $event)"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm">
            <label [for]="'edit-all-' + g.customer" class="ms-2 text-sm font-medium text-app-teal-100">All {{g.wildcard}} scanners</label>
          </div>
          <div *ngFor="let scanner of g.scanners" class="flex items-center py-0.5 pl-5">
            <input [id]="'edit-' + scanner.Id" type="checkbox"
              [checked]="is_edit_scanner_checked(scanner.Id, g)"
              [disabled]="is_edit_scanner_disabled(g)"
              (change)="on_user_scanner_change(scanner, $event)"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm disabled:opacity-50">
            <label [for]="'edit-' + scanner.Id" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300" [class.opacity-50]="is_edit_scanner_disabled(g)">{{scanner.Name}} <span class="text-xs text-gray-500">({{scanner.Id}})</span></label>
          </div>
        </div>
      </div>

      <button type="submit" (click)="update_user_scanners()" class="dark-btn-primary w-full mt-8">
        Save
      </button>
      <button (click)="showEditUserScannersModal = false" class="dark-btn-secondary w-full mt-1">
        Cancel
      </button>
    </div>
  </div>
</div>

<!-- Edit Customers modal -->
<div *ngIf="showEditUserCustomersModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.8)]">
  <div class="flex-0 w-auto p-6 bg-white">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-clone text-app-teal-100 mr-2"></i> Customers assignment
    </h1>
    <div class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300 dark:text-gray-200">
      <p>Select the customers to assign for:</p>
      <h2 class="w-full text-center font-semibold text-app-teal-100">
        {{ selected_user?.attributes?.name || '' }} {{ selected_user?.attributes?.family_name || '' }}
        <span *ngIf="!(selected_user?.attributes?.name || selected_user?.attributes?.family_name)"
              class="text-gray-300">{{ selected_user?.attributes?.email || selected_user?.username }}</span>
      </h2>
      <!-- Source of truth: F2-ADMIN.Customers (directoryCustomers). Was
           previously iterating the distinct Scanners.Client array which
           silently dropped customers that exist in the directory but
           have no scanner rows yet. -->
      <table class="mt-4 max-h-[50vh] overflow-y-auto block">
        <tbody>
          <tr *ngFor="let customer of directoryCustomers">
            <td class="py-2 px-4">
              <div class="flex items-center">
                <div class="flex items-center h-5">
                    <input [id]="'cust-' + customer._id" type="checkbox"
                           [checked]="is_customer_assigned(customer)"
                           [disabled]="is_customer_lock_required(customer) || is_customer_add_blocked(customer)"
                           (change)="on_customer_toggle(customer, $event)"
                           [title]="is_customer_lock_required(customer) ? 'This user lives in the ' + customer._id + ' Cognito pool — their own customer slug cannot be removed. Move them to legacy first if you really want this.' : (is_customer_add_blocked(customer) ? customer._id + ' runs its own Cognito pool. Add the user there directly so they land in the right pool with seeded data; granting from here would create an out-of-pool legacy claim.' : '')"
                           class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm disabled:opacity-60 disabled:cursor-not-allowed">
                </div>
                <div class="ms-2 text-sm">
                  <label [for]="'cust-' + customer._id" class="font-medium text-gray-900 dark:text-gray-300">
                    {{ customer.name || customer._id }}
                    <!-- Lock pill — tells the admin WHY the checkbox is
                         disabled (avoids "why won't this uncheck?" support
                         load). Only renders for the row's own pool slug. -->
                    <span *ngIf="is_customer_lock_required(customer)"
                          class="ml-2 px-1.5 py-0.5 rounded text-[10px] bg-purple-900 text-purple-200"
                          title="User lives in this customer's Cognito pool — slug is required">
                      <i class="fa-solid fa-lock mr-1 text-[9px]"></i>pool-locked
                    </span>
                    <!-- Out-of-pool grant gate — customer runs its own
                         Cognito pool. Admin must add the user via that
                         pool's UX (or pool-cutover seeding); granting
                         from here would orphan them in legacy. Only
                         renders for currently-UNCHECKED customers with
                         a cognito_pool; once checked (erroneous claim
                         case) the checkbox unlocks so admin can clean
                         it up. -->
                    <span *ngIf="is_customer_add_blocked(customer)"
                          class="ml-2 px-1.5 py-0.5 rounded text-[10px] bg-slate-700 text-slate-300"
                          title="Customer runs its own Cognito pool — grant from inside that pool's user list, not here">
                      <i class="fa-solid fa-shield-halved mr-1 text-[9px]"></i>own pool
                    </span>
                  </label>
                  <p class="text-xs font-normal text-gray-500">
                    {{ customer._id }}<span *ngIf="customer.aliases?.length">
                      &nbsp;·&nbsp;aliases: {{ customer.aliases.join(', ') }}</span>
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Unrecognized slugs: anything in the user's custom:customers
           that matches NO directory row (by _id or alias). Surfaces
           legacy / typo / withdrawn customer slugs so the admin can
           see what's there and remove on save. -->
      <div *ngIf="unrecognized_user_slugs.length" class="mt-4 pt-3 border-t border-gray-700">
        <p class="text-xs uppercase tracking-wide text-amber-300 mb-2">
          <i class="fa-solid fa-triangle-exclamation mr-1"></i>
          Unrecognized slugs (not in F2-ADMIN.Customers)
        </p>
        <table class="block">
          <tbody>
            <tr *ngFor="let slug of unrecognized_user_slugs">
              <td class="py-1 px-4">
                <div class="flex items-center">
                  <div class="flex items-center h-5">
                    <input [id]="'unk-' + slug" type="checkbox" checked
                           (change)="on_unrecognized_slug_toggle(slug, $event)"
                           class="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 rounded-sm">
                  </div>
                  <div class="ms-2 text-sm">
                    <label [for]="'unk-' + slug" class="font-medium text-amber-300">{{ slug }}</label>
                    <p class="text-xs font-normal text-gray-500">Uncheck to remove on save</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button type="submit" (click)="update_user_customers()" class="dark-btn-primary w-full mt-8">
        Save
      </button>
      <button (click)="showEditUserCustomersModal = false" class="dark-btn-secondary w-full mt-1">
        Cancel
      </button>
    </div>
  </div>
</div>

<!-- IT-F2-106 Phase 3d: Add-User Claims modal REMOVED. Claims now
     render inline via <app-inline-scanner-claims> inside each
     enabled scanner accordion row. Edit-user Claims modal below is
     UNCHANGED per Mike's Q5=C. -->

<!-- Claims editor modal — reusable standalone component -->
<app-claims-editor *ngIf="showEditUserClaimsModal"
  [customers]="directoryCustomers"
  [scanners]="scanners"
  [userScanners]="selected_user_for_claims?.attributes?.['custom:scanners'] || ''"
  [userRole]="selected_user_for_claims?.attributes?.['custom:role'] || ''"
  [claimsJson]="selected_user_claims_json"
  [title]="'Edit Claims'"
  [userDisplayName]="((selected_user_for_claims?.attributes?.name || '') + ' ' + (selected_user_for_claims?.attributes?.family_name || '')).trim()"
  [userEmail]="selected_user_for_claims?.attributes?.email || selected_user_for_claims?.email || selected_user_for_claims?.username || ''"
  (save)="on_save_user_claims($event)"
  (close)="showEditUserClaimsModal = false">
</app-claims-editor>

<!-- Unified access editor — drives custom:customers + custom:scanners in one save.
     Mike 2026-06-28. Pool-mismatched customers are hidden — UNLESS the
     target is an admin, in which case the pool filter is bypassed and
     every customer is pickable (Mike 2026-07-06, userRole binding). -->
<app-access-editor *ngIf="showEditUserAccessModal"
  [customers]="directoryCustomers"
  [scanners]="scanners"
  [userCustomers]="selected_user_for_access?.attributes?.['custom:customers'] || ''"
  [userScanners]="selected_user_for_access?.attributes?.['custom:scanners'] || ''"
  [userPoolId]="selected_user_for_access?.pool_id || ''"
  [userRole]="selected_user_for_access?.attributes?.['custom:role'] || ''"
  [userOwnSlug]="selected_user_for_access?.customer_slug || ''"
  [title]="'Edit Access'"
  [userDisplayName]="((selected_user_for_access?.attributes?.name || '') + ' ' + (selected_user_for_access?.attributes?.family_name || '')).trim()"
  [userEmail]="selected_user_for_access?.attributes?.email || selected_user_for_access?.email || selected_user_for_access?.username || ''"
  [saving]="savingUserAccess"
  (save)="on_save_user_access($event)"
  (close)="showEditUserAccessModal = false">
</app-access-editor>

<!-- Channels editor modal — sibling of claims editor; same shape, different attribute. -->
<app-channels-editor *ngIf="showEditUserChannelsModal"
  [customers]="directoryCustomers"
  [scanners]="scanners"
  [userScanners]="selected_user_for_channels?.attributes?.['custom:scanners'] || ''"
  [userRole]="selected_user_for_channels?.attributes?.['custom:role'] || ''"
  [channelsJson]="selected_user_channels_json"
  [title]="'Edit Channels'"
  [userDisplayName]="((selected_user_for_channels?.attributes?.name || '') + ' ' + (selected_user_for_channels?.attributes?.family_name || '')).trim()"
  [userEmail]="selected_user_for_channels?.attributes?.email || selected_user_for_channels?.email || selected_user_for_channels?.username || ''"
  [userPoolId]="selected_user_for_channels?.pool_id || ''"
  (save)="on_save_user_channels($event)"
  (saveScannerChannels)="on_save_scanner_channels($event)"
  (close)="showEditUserChannelsModal = false">
</app-channels-editor>

<!-- Override Password modal. Bulk admin password set via AWS
     AdminSetUserPassword (NO email). Default suggests a random 16-char
     value that satisfies Cognito's policy; admin can overtype with
     something specific. Temporary flag forces NEW_PASSWORD_REQUIRED on
     next sign-in. -->
<div *ngIf="showOverridePasswordModal"
     class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-[calc(100%-1rem)] max-h-full
            flex flex-col justify-center items-center
            dark:bg-[rgba(1,1,1,0.8)]">
  <div class="relative max-w-md w-full mx-4 rounded-lg shadow-lg dark:bg-app-black-500 dark:text-gray-300 p-6">
    <h3 class="text-lg font-semibold mb-3">
      <i class="fa-solid fa-key text-amber-400 mr-2"></i>
      Override Password
      <span class="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
        ({{ selected_users_for_password.length }} user{{ selected_users_for_password.length === 1 ? '' : 's' }})
      </span>
    </h3>

    <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
      AWS AdminSetUserPassword — <b>no email is sent</b>. Bypasses the SES quota path.
      Give the password to the user out-of-band.
    </p>

    <!-- Selected user summary. Renders only the first 10 emails so a
         1000-row select-all doesn't lock the browser building a giant
         ngFor (Mike froze admin.f2-tech.ai by selecting ~1000 rows --
         the *ngFor was the bottleneck, not the backend). The overage
         count keeps the operator informed without paying the DOM cost. -->
    <div *ngIf="selected_users_for_password.length > 0" class="text-xs mb-3 max-h-28 overflow-y-auto border border-gray-300 dark:border-[#434863] rounded p-2 bg-gray-50 dark:bg-app-black-100">
      <div *ngFor="let u of selected_users_for_password | slice:0:10; trackBy: trackByUsername" class="leading-tight flex items-center gap-1.5 flex-wrap">
        <!-- Email is the human-readable identity the operator recognizes.
             For legacy pool entries Cognito Username is a UUID; for per-
             customer pools Username = email. Always lead with email. -->
        <span class="font-mono">{{ u.attributes?.email || u.username }}</span>
        <!-- Pool pill — tells the operator which Cognito pool this row
             writes into. F2 (legacy) in blue, per-customer pools in
             purple. Matches the grid's Pool column styling. -->
        <span *ngIf="u.customer_slug === 'f2'" class="px-1.5 py-0.5 rounded text-[10px] bg-blue-900 text-blue-200">F2 (legacy)</span>
        <span *ngIf="u.customer_slug && u.customer_slug !== 'f2'" class="px-1.5 py-0.5 rounded text-[10px] bg-purple-900 text-purple-200">{{ u.customer_slug }}</span>
        <!-- Show Username only when it differs from email AND isn't a
             plain duplicate (legacy users have UUID usernames; helpful
             for support to copy/paste into AWS console). -->
        <span *ngIf="u.attributes?.email && u.username && u.attributes.email !== u.username" class="text-gray-500 dark:text-gray-400 text-[10px]">({{ u.username }})</span>
      </div>
      <div *ngIf="selected_users_for_password.length > 10" class="text-gray-500 dark:text-gray-400 italic mt-1">
        …and {{ selected_users_for_password.length - 10 }} more.
      </div>
    </div>

    <!-- Mode toggle. Operator preference persists in localStorage; the
         default ('stored') is what most support workflows want (consistent
         password across a customer's affected users). 'unique' falls back
         to the legacy one-random-applied-to-all behavior. -->
    <div class="flex gap-2 mb-2 text-xs flex-wrap">
      <label class="flex items-center gap-1.5 cursor-pointer">
        <input type="radio" name="overridePwMode"
               [checked]="override_password_mode === 'stored'"
               [disabled]="override_password_busy"
               (change)="setOverridePasswordMode('stored')" />
        <span class="text-gray-900 dark:text-white"><b>Customer stored</b></span>
      </label>
      <label class="flex items-center gap-1.5 cursor-pointer">
        <input type="radio" name="overridePwMode"
               [checked]="override_password_mode === 'unique'"
               [disabled]="override_password_busy"
               (change)="setOverridePasswordMode('unique')" />
        <span class="text-gray-900 dark:text-white"><b>Unique auto-generated</b></span>
      </label>
      <label class="flex items-center gap-1.5 cursor-pointer">
        <input type="radio" name="overridePwMode"
               [checked]="override_password_mode === 'user_supplied'"
               [disabled]="override_password_busy"
               (change)="setOverridePasswordMode('user_supplied')" />
        <span class="text-gray-900 dark:text-white"><b>One-time (user-supplied)</b></span>
      </label>
      <!-- Magic-link mode: viable whenever EITHER the SES Send path OR the
           Copy-link path will succeed. Copy-link works regardless of pool
           SES wiring (it just mints + clipboards a token), so this radio
           is no longer gated by SES-readiness — only by busy state.
           Mike 2026-06-26: "as long as the send OR copy option is viable
           the magic-link invite option should be enabled." -->
      <label class="flex items-center gap-1.5 cursor-pointer"
             [title]="overridePasswordMagicLinkBlockedUsers.length === selected_users_for_password.length && selected_users_for_password.length > 0
               ? 'Send is unavailable for these selected rows (legacy / unmigrated pool, no SES branded sender). Copy link still works for a single selected user — admin pastes the URL to the user via Slack/SMS.'
               : (overridePasswordMagicLinkBlockedUsers.length > 0
                   ? overridePasswordMagicLinkBlockedUsers.length + ' selected row(s) are on the legacy pool — Send will skip them; use Copy link one-at-a-time.'
                   : '')">
        <input type="radio" name="overridePwMode"
               [checked]="override_password_mode === 'magic_link'"
               [disabled]="override_password_busy"
               (change)="setOverridePasswordMode('magic_link')" />
        <span class="text-gray-900 dark:text-white"><b>Magic-link invite</b></span>
      </label>
    </div>

    <!-- Stored mode: one row per distinct customer in the selection. Each
         shows the customer's stored override password (decrypted server-
         side), with per-row Generate (rotate) + Copy buttons. Applying the
         override side-effects an update of the stored value so the same
         row shows the latest value next open. -->
    <ng-container *ngIf="override_password_mode === 'stored'">
      <label class="block text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">
        Stored passwords ({{ override_password_distinct_customers.length }} customer{{ override_password_distinct_customers.length === 1 ? '' : 's' }})
      </label>
      <div class="space-y-2 mb-3">
        <div *ngFor="let slug of override_password_distinct_customers"
             class="flex items-center gap-2">
          <!-- Label resolves through F2-ADMIN.Customers (with alias
               awareness via _normalize_slug / _customer_name_for_slug)
               so a stale-cache user still carrying 'hima' renders as
               "HIMA Reddy" + the canonical slug in the tooltip. Amber
               when the slug matches no directory row at all. -->
          <span class="text-xs w-32 truncate"
                [title]="slug"
                [class.text-gray-700]="!_is_unrecognized_slug(slug)"
                [class.dark:text-gray-300]="!_is_unrecognized_slug(slug)"
                [class.text-amber-600]="_is_unrecognized_slug(slug)"
                [class.dark:text-amber-300]="_is_unrecognized_slug(slug)">
            <span class="font-medium">{{ _customer_name_for_slug(slug) }}</span>
            <span class="ml-1 text-[10px] font-mono opacity-70">{{ slug }}</span>
          </span>
          <input type="text"
                 [(ngModel)]="override_password_stored[slug]"
                 [disabled]="override_password_busy || override_password_stored_loading[slug]"
                 [placeholder]="override_password_stored_loading[slug] ? 'Loading…' : '(none stored)'"
                 class="flex-1 bg-white border border-gray-300 text-gray-900 rounded px-2 py-1 text-xs font-mono dark:bg-app-black-100 dark:border-[#434863] dark:text-white" />
          <button type="button" class="dark-btn dark-btn-sm"
                  [disabled]="override_password_busy"
                  (click)="regenerateStoredPasswordFor(slug)"
                  title="Replace this customer's stored value with a fresh random 16-char password (stickier on Apply)">
            <i class="fa-solid fa-arrows-rotate"></i>
          </button>
          <button type="button" class="dark-btn dark-btn-sm"
                  [disabled]="override_password_busy || !override_password_stored[slug]"
                  (click)="copyText(override_password_stored[slug], slug + ' password')"
                  title="Copy this customer's stored password">
            <i class="fa-regular fa-copy"></i>
          </button>
        </div>
      </div>
      <p class="text-[11px] text-gray-500 dark:text-gray-400 mb-3">
        Per-customer stored password (AES-256-GCM encrypted at rest). Each selected user gets THEIR customer's value.
        Applying side-effects an update of the stored value to match what was applied — next open shows the latest.
      </p>
    </ng-container>

    <!-- Unique mode: legacy single-password-applied-to-all behavior. -->
    <ng-container *ngIf="override_password_mode === 'unique'">
      <label class="block text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">Password (applied to all)</label>
      <div class="flex gap-2 mb-3">
        <input type="text"
               [(ngModel)]="override_password_value"
               [disabled]="override_password_busy"
               class="flex-1 bg-white border border-gray-300 text-gray-900 rounded px-3 py-1.5 text-sm font-mono dark:bg-app-black-100 dark:border-[#434863] dark:text-white" />
        <button type="button" class="dark-btn"
                [disabled]="override_password_busy"
                (click)="regenerate_override_password()"
                title="Generate a new random 16-char password">
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
        <button type="button" class="dark-btn"
                [disabled]="override_password_busy"
                (click)="copy_override_password()"
                title="Copy to clipboard">
          <i class="fa-regular fa-copy"></i>
        </button>
      </div>
      <p class="text-[11px] text-gray-500 dark:text-gray-400 mb-3">
        One password applies to every selected user. Each user's customer(s) also get their stored override updated to this value.
      </p>
    </ng-container>

    <!-- One-time / user-supplied mode: admin types the password the user
         told them. Applied as the user's actual permanent password. The
         customer's stored override is NOT touched (this is a courtesy
         application, not a rotation event). -->
    <ng-container *ngIf="override_password_mode === 'user_supplied'">
      <label class="block text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">Password (told by user)</label>
      <div class="flex gap-2 mb-3">
        <input type="text"
               [(ngModel)]="override_password_user_supplied"
               [disabled]="override_password_busy"
               placeholder="What the user wants their password to be…"
               class="flex-1 bg-white border border-gray-300 text-gray-900 rounded px-3 py-1.5 text-sm font-mono dark:bg-app-black-100 dark:border-[#434863] dark:text-white" />
        <button type="button" class="dark-btn"
                [disabled]="override_password_busy || !override_password_user_supplied"
                (click)="copyText(override_password_user_supplied, 'Password')"
                title="Copy to clipboard">
          <i class="fa-regular fa-copy"></i>
        </button>
      </div>
      <p class="text-[11px] text-gray-500 dark:text-gray-400 mb-3">
        User told you their preferred password; this sets it as their permanent password (no auto-generate).
        The customer's <b>stored</b> override is <i>not</i> touched — this is a one-time application, not a rotation.
      </p>
    </ng-container>

    <!-- Magic-link mode: no password to communicate. Backend mints a
         one-time invite token per user and sends a branded
         "Welcome — set your password" email from the user's pool's SES
         identity (e.g. support@optionpit.com for option-pit pool users).
         User clicks email link → /accept-invite?token=... → picks their
         own password → cleared FORCE_CHANGE_PASSWORD + ready to sign in.
         The Apply button just kicks off the per-user invite loop. -->
    <ng-container *ngIf="override_password_mode === 'magic_link'">
      <div class="p-3 rounded border border-gray-300 dark:border-[#434863] bg-gray-50 dark:bg-app-black-100/40 mb-3">
        <div class="text-xs space-y-2 text-gray-700 dark:text-gray-300">
          <div>
            <i class="fa-solid fa-envelope-circle-check text-app-teal-100 mr-1"></i>
            <b>Each selected user gets a branded email</b> from their pool's SES identity
            (e.g. <code class="font-mono">support&#64;optionpit.com</code> for option-pit users)
            with a one-time "set your password" link.
          </div>
          <div class="text-gray-500 dark:text-gray-400">
            Link is valid for 7 days, single-use. Clearing the user's
            <code class="font-mono">FORCE_CHANGE_PASSWORD</code> state is automatic on redeem
            (AdminSetUserPassword permanent).
          </div>
          <div *ngIf="has_legacy_user_in_password_selection()" class="text-amber-700 dark:text-amber-300">
            <i class="fa-solid fa-triangle-exclamation mr-1"></i>
            Your selection includes <b>legacy-pool</b> users.
            <b>Send</b> will fail for those (only per-customer pools have a branded SES sender configured) —
            use <b>Copy link</b> instead and hand it off out-of-band.
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Temporary flag is meaningless for magic-link mode (user picks
         their own permanent password on redeem). Hide in that mode.
         For user_supplied the default is OFF (user told you what they
         want, so it should stick) but we still expose the toggle. -->
    <label *ngIf="override_password_mode !== 'magic_link'"
           class="text-sm flex items-center gap-2 mb-4 text-gray-900 dark:text-white">
      <input type="checkbox"
             [(ngModel)]="override_password_temporary"
             [disabled]="override_password_busy" />
      <span><b>Temporary</b> — user must change password on next sign-in. AWS will <i>not</i> email anything; you tell the user the temp password out-of-band.</span>
    </label>

    <!-- Live progress bar (multi-user override can take minutes at
         hundreds of users; the bar tells the operator we're still
         making forward progress instead of frozen). -->
    <div *ngIf="override_password_busy" class="mb-3">
      <div class="text-xs mb-1 flex justify-between text-gray-700 dark:text-gray-300">
        <span>
          {{ override_password_progress.done }} / {{ override_password_progress.total }}
          <span class="text-emerald-600 dark:text-emerald-400 ml-2">✓ {{ override_password_progress.ok }}</span>
          <span class="text-red-500 dark:text-red-400 ml-2">✗ {{ override_password_progress.fail }}</span>
        </span>
        <span class="text-gray-500 dark:text-gray-400 truncate ml-2" [title]="override_password_progress.current_user">
          {{ override_password_progress.current_user }}
        </span>
      </div>
      <div class="h-2 rounded bg-gray-200 dark:bg-app-black-100 overflow-hidden">
        <div class="h-full bg-emerald-500 transition-[width] duration-100"
             [style.width.%]="override_password_progress.total > 0
               ? (override_password_progress.done * 100 / override_password_progress.total)
               : 0"></div>
      </div>
    </div>

    <div class="flex gap-2">
      <button type="button" class="dark-btn-primary flex-1"
              [class.dark-btn-disabled]="override_password_busy || (override_password_mode === 'magic_link' && overridePasswordMagicLinkBlockedUsers.length > 0)"
              [disabled]="override_password_busy || (override_password_mode === 'magic_link' && overridePasswordMagicLinkBlockedUsers.length > 0)"
              [title]="(override_password_mode === 'magic_link' && overridePasswordMagicLinkBlockedUsers.length > 0)
                ? 'Magic-link unavailable for ' + overridePasswordMagicLinkBlockedUsers.length + ' selected user(s) on the legacy / unmigrated pool (no SES branded sender). Use Stored / Unique / User-supplied password instead for those rows, or migrate them to a per-customer pool first.'
                : ''"
              (click)="submit_override_password()">
        <ng-container *ngIf="!override_password_busy">
          <ng-container *ngIf="override_password_mode === 'magic_link'; else passwordCta">
            <ng-container *ngIf="selected_users_for_password.length === 1; else multiMl">
              Send magic-link to <code class="text-xs">{{ selected_users_for_password[0].attributes?.email || selected_users_for_password[0].username }}</code>
            </ng-container>
            <ng-template #multiMl>Send magic-link to {{ selected_users_for_password.length }} users</ng-template>
          </ng-container>
          <ng-template #passwordCta>
            <ng-container *ngIf="selected_users_for_password.length === 1; else multi">
              Reset password for <code class="text-xs">{{ selected_users_for_password[0].attributes?.email || selected_users_for_password[0].username }}</code>
            </ng-container>
            <ng-template #multi>Apply to {{ selected_users_for_password.length }} users</ng-template>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="override_password_busy">
          <ng-container *ngIf="override_password_mode === 'magic_link'">Sending… {{ override_password_progress.done }}/{{ override_password_progress.total }}</ng-container>
          <ng-container *ngIf="override_password_mode !== 'magic_link'">Applying… {{ override_password_progress.done }}/{{ override_password_progress.total }}</ng-container>
        </ng-container>
      </button>
      <!-- Magic-link mode + 1 user selected: extra "Copy link" button so
           the admin can paste the URL to the user via Slack/SMS instead
           of (or in addition to) the email send. Hidden when N != 1
           because bulk-copy to clipboard is awkward. -->
      <button *ngIf="override_password_mode === 'magic_link' && selected_users_for_password.length === 1"
              type="button" class="dark-btn"
              [disabled]="override_password_busy || override_password_copy_link_busy"
              [class.dark-btn-disabled]="override_password_busy || override_password_copy_link_busy"
              (click)="copy_magic_link_for_selected()"
              title="Mint a magic-link URL and copy to clipboard (no email sent). Same single-use 7-day token shape as the Send button.">
        <i class="fa-regular fa-copy mr-1"></i>
        <ng-container *ngIf="!override_password_copy_link_busy">Copy link</ng-container>
        <ng-container *ngIf="override_password_copy_link_busy">Minting…</ng-container>
      </button>
      <!-- Cancel doubles as Stop while the bulk is running. -->
      <button type="button" class="dark-btn-secondary"
              (click)="override_password_busy ? cancel_override_password() : close_override_password()"
              [title]="override_password_busy ? 'Stop after the current user (already-processed users keep their new password)' : 'Close without applying'">
        {{ override_password_busy ? 'Stop' : 'Cancel' }}
      </button>
    </div>
  </div>
</div>

<!-- Impersonate (view-as-user) modal. Opens a new tab landing on
     either the target's customer members portal OR a specific
     scanner, marked with `?impersonate_as=…` so the destination SPA
     can render a persistent banner. Admin's own JWTs flow with the
     sid -- this is UI-shadow impersonation, not full credential
     replacement (Cognito has no clean primitive for that without the
     target's password). -->
<div *ngIf="showImpersonateModal"
     class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-[calc(100%-1rem)] max-h-full
            flex flex-col justify-center items-center
            dark:bg-[rgba(1,1,1,0.8)]">
  <div class="relative max-w-md w-full mx-4 rounded-lg shadow-lg dark:bg-app-black-500 dark:text-gray-300 p-6">
    <h3 class="text-lg font-semibold mb-3">
      <i class="fa-solid fa-user-secret text-fuchsia-400 mr-2"></i>
      View as User
    </h3>

    <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
      Opens a new tab signed in with admin credentials BUT marked as
      impersonating the target. The destination SPA renders a visible
      banner so the impersonation is never hidden. Every successful
      handoff is audit-logged.
    </p>

    <div class="text-xs mb-3 border border-gray-300 dark:border-[#434863] rounded p-2 bg-gray-50 dark:bg-app-black-100">
      <div class="text-gray-500 dark:text-gray-400 uppercase tracking-wide text-[10px] mb-0.5">Target</div>
      <div class="leading-tight">
        <ng-container *ngIf="impersonate_target_name() as nm">
          <span class="font-semibold text-gray-900 dark:text-white">{{ nm }}</span>
          <span class="text-gray-500 dark:text-gray-400"> &lt;{{ impersonate_target_email_display() }}&gt;</span>
        </ng-container>
        <span *ngIf="!impersonate_target_name()" class="font-mono">{{ impersonate_target_email_display() }}</span>
      </div>
      <div *ngIf="impersonate_target?.pool_id" class="text-[10px] text-gray-500 dark:text-gray-400 mt-1">
        <span>pool: <span class="font-medium">{{ impersonate_target_pool_label() }}</span></span>
        <span class="font-mono opacity-70 ml-1">({{ impersonate_target.pool_id }})</span>
      </div>
    </div>

    <label class="block text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">Open</label>
    <div class="flex flex-col gap-2 mb-3">
      <label class="text-sm flex items-center gap-2 text-gray-900 dark:text-white">
        <input type="radio" name="impersonate_kind" value="members"
               [checked]="impersonate_kind === 'members'"
               (change)="impersonate_kind = 'members'"
               [disabled]="impersonate_busy" />
        <span>Members page (target's customer-branded portal)</span>
      </label>
      <label class="text-sm flex items-center gap-2 text-gray-900 dark:text-white">
        <input type="radio" name="impersonate_kind" value="scanner"
               [checked]="impersonate_kind === 'scanner'"
               (change)="impersonate_kind = 'scanner'"
               [disabled]="impersonate_busy" />
        <span>Specific scanner</span>
      </label>
    </div>

    <div *ngIf="impersonate_kind === 'scanner'" class="mb-4">
      <label class="block text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">Scanner</label>
      <select [(ngModel)]="impersonate_scanner_id"
              [disabled]="impersonate_busy"
              class="w-full bg-white border border-gray-300 text-gray-900 rounded px-3 py-1.5 text-sm dark:bg-app-black-100 dark:border-[#434863] dark:text-white">
        <option value="">— pick a scanner from the target's entitlements —</option>
        <option *ngFor="let sid of impersonate_target_scanner_ids()" [value]="sid">{{ scanner_label(sid) }}</option>
      </select>
      <p *ngIf="impersonate_target_scanner_ids().length === 0" class="mt-2 text-xs text-amber-400">
        Target has no <code>custom:scanners</code> entries. Use Members page or grant them a scanner first.
      </p>
    </div>

    <ng-container *ngIf="!impersonate_result_url">
      <div class="flex gap-2">
        <button type="button" class="dark-btn-primary flex-1"
                [class.dark-btn-disabled]="impersonate_busy || (impersonate_kind === 'scanner' && !impersonate_scanner_id)"
                [disabled]="impersonate_busy || (impersonate_kind === 'scanner' && !impersonate_scanner_id)"
                (click)="submit_impersonate()">
          <ng-container *ngIf="!impersonate_busy">
            <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>
            Open in New Tab
          </ng-container>
          <ng-container *ngIf="impersonate_busy">Preparing…</ng-container>
        </button>
        <button type="button" class="dark-btn-secondary"
                [disabled]="impersonate_busy"
                (click)="close_impersonate()">
          Cancel
        </button>
      </div>
    </ng-container>

    <!-- Post-mint result panel. Tab is already open via window.open;
         this keeps the URL on screen with a Copy button so admin can
         paste it into a support ticket / Slack thread for the user
         hitting the issue. The URL embeds the impersonate_as marker
         so a support teammate opening it sees the same banner. -->
    <ng-container *ngIf="impersonate_result_url">
      <div class="mt-2 mb-3 p-3 rounded border border-emerald-700/40 bg-emerald-900/20">
        <div class="text-xs uppercase tracking-wide text-emerald-300 mb-1">
          <i class="fa-solid fa-circle-check mr-1"></i> Opened in new tab
        </div>
        <div class="text-xs text-gray-400 mb-1">Viewing as <code class="text-app-teal-100">{{ impersonate_result_target_display || impersonate_result_target_email }}</code>.</div>
        <div *ngIf="impersonate_result_expires_at" class="text-[10px] text-amber-300/90 mb-2">
          <i class="fa-regular fa-clock mr-1"></i>
          Link valid until {{ fmtDate(impersonate_result_expires_at) }} (matches access-token session window)
        </div>
        <div class="text-[10px] text-gray-500 uppercase tracking-wide mb-1">Shareable URL</div>
        <div class="font-mono text-[11px] break-all bg-gray-50 dark:bg-app-black-100 border border-gray-300 dark:border-[#434863] rounded p-2 max-h-32 overflow-y-auto">
          {{ impersonate_result_url }}
        </div>
      </div>
      <div class="flex gap-2">
        <button type="button" class="dark-btn flex-1"
                (click)="copy_impersonate_url()"
                title="Copy URL to clipboard (sid expires in ~90s; paste into Slack/ticket quickly)">
          <i class="fa-regular fa-copy mr-1"></i> Copy URL
        </button>
        <button type="button" class="dark-btn"
                (click)="reopen_impersonate_url()"
                title="Open the same URL in another new tab">
          <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i> Reopen
        </button>
        <button type="button" class="dark-btn-secondary"
                (click)="close_impersonate()">
          Done
        </button>
      </div>
    </ng-container>
  </div>
</div>

<!-- Welcome Email preview + send modal — opened from Actions → Send Welcome Email. -->
<app-welcome-email-modal #welcomeEmailModal
  [show]="showWelcomeEmailModal"
  [users]="welcomeEmailUsers"
  (closed)="onWelcomeEmailClosed()"
  (sent)="onWelcomeEmailSent($event)"
  (copyMagicLinkFor)="onWelcomeEmailCopyMagicLink($event)">
</app-welcome-email-modal>

<!-- IT-F2-407 (Mike 2026-09-18): CSV import field-mapping wizard.
     Opens on file drop; per-column dropdown (Email/First/Last/Role/
     Scanners/Ignore), header-row toggle (auto-detected), preview of first
     5 data rows. Email is the only hard requirement; missing First/Last
     routes the invitee via magic-link path. -->
<div *ngIf="csvMapDialogOpen"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
     (click)="csvMapCancel()">
  <div class="bg-white dark:bg-app-black-500 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col border border-gray-300 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="px-4 py-3 border-b border-gray-200 dark:border-[#434863] flex items-center gap-3">
      <i class="fa-solid fa-file-csv text-app-teal-100"></i>
      <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex-1">Import Users &mdash; Map Columns</h2>
      <button type="button" (click)="csvMapCancel()" class="text-gray-500 dark:text-gray-400 hover:text-app-teal-100" [disabled]="csvMapImporting">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="px-4 py-3 flex-1 overflow-auto">
      <div class="flex items-center gap-3 mb-3">
        <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 select-none cursor-pointer">
          <input type="checkbox" [(ngModel)]="csvMapHasHeader" (ngModelChange)="csvMapOnHeaderToggle()"
                 class="rounded border-gray-300 dark:border-[#434863] focus:ring-app-teal-100" [disabled]="csvMapImporting">
          First row is header
        </label>
        <span class="text-xs text-gray-500 dark:text-gray-400 ml-auto" *ngIf="csvMapRawRows.length">
          {{ (csvMapHasHeader ? csvMapRawRows.length - 1 : csvMapRawRows.length) }} data row{{ (csvMapHasHeader ? csvMapRawRows.length - 1 : csvMapRawRows.length) === 1 ? '' : 's' }}
        </span>
      </div>

      <!-- IT-F2-407 (Mike 2026-09-18 c/6c058572): inline pre-flight summary.
           Shows how many of the mapped emails already exist in the target
           pool BEFORE the operator hits Import. Loading state while the
           parallel /lookup-pools-for-email fan-out completes. -->
      <div *ngIf="csvMapCustomer && csvMapEmailColumnPicked" class="mb-3 text-xs">
        <div *ngIf="csvMapPreflightRunning" class="p-2 border border-gray-300 dark:border-[#434863] rounded bg-gray-50 dark:bg-app-black-100/40 flex items-center gap-2 text-gray-600 dark:text-gray-300">
          <i class="fa-solid fa-spinner fa-spin"></i>
          Checking which emails already exist in the target pool…
        </div>
        <div *ngIf="!csvMapPreflightRunning && csvMapExistingCount > 0"
             class="p-2 border border-red-500/40 bg-red-500/10 rounded text-red-700 dark:text-red-300 flex items-start gap-2">
          <i class="fa-solid fa-circle-exclamation mt-0.5"></i>
          <div class="flex-1">
            <div><strong>{{ csvMapExistingCount }} of {{ csvMapTotalEmailCount }}</strong> email{{ csvMapExistingCount === 1 ? '' : 's' }} already exist in the target pool (flagged red in the preview below). They will be skipped on Import.</div>
            <!-- IT-F2-407 (Mike 2026-09-18 c/2f26d0db): "we should probably
                 have a check box on there to send password reset emails to
                 those that already exist (there's probably a reason their
                 email is there)". -->
            <label class="mt-1 inline-flex items-center gap-2 select-none cursor-pointer text-red-700 dark:text-red-300">
              <input type="checkbox" [(ngModel)]="csvMapResetExisting"
                     class="rounded border-red-500/60 focus:ring-red-500" [disabled]="csvMapImporting">
              Also send a password-reset email to the {{ csvMapExistingCount }} already-existing user{{ csvMapExistingCount === 1 ? '' : 's' }}.
            </label>
          </div>
        </div>
        <div *ngIf="!csvMapPreflightRunning && csvMapExistingCount === 0 && csvMapTotalEmailCount > 0"
             class="p-2 border border-green-500/40 bg-green-500/10 rounded text-green-700 dark:text-green-300 flex items-center gap-2">
          <i class="fa-solid fa-circle-check"></i>
          All {{ csvMapTotalEmailCount }} email{{ csvMapTotalEmailCount === 1 ? '' : 's' }} are new to the target pool.
        </div>
        <!-- IT-F2-407 c/4e907c83 — welcome-email send on bulk-add entitlement.
             Only shows when at least one existing user will gain new scanners
             (csvMapEntitlementCount > 0). Mirrors the reset-existing checkbox
             pattern above. -->
        <div *ngIf="!csvMapPreflightRunning && csvMapEntitlementCount > 0"
             class="p-2 border border-amber-500/50 bg-amber-500/10 rounded text-amber-700 dark:text-amber-300 flex items-start gap-2">
          <i class="fa-solid fa-plus mt-0.5"></i>
          <div class="flex-1">
            <div><strong>{{ csvMapEntitlementCount }}</strong> existing user{{ csvMapEntitlementCount === 1 ? '' : 's' }} will gain new scanner entitlement{{ csvMapEntitlementCount === 1 ? '' : 's' }} on Import (amber &ldquo;+N entitlement&rdquo; rows in the preview).</div>
            <label class="mt-1 inline-flex items-center gap-2 select-none cursor-pointer text-amber-700 dark:text-amber-300">
              <input type="checkbox" [(ngModel)]="csvMapWelcomeEntitled"
                     class="rounded border-amber-500/60 focus:ring-amber-500" [disabled]="csvMapImporting">
              Also send a welcome email to the {{ csvMapEntitlementCount }} entitled user{{ csvMapEntitlementCount === 1 ? '' : 's' }} (routes magic-link vs activation per recipient).
            </label>
          </div>
        </div>
      </div>

      <!-- IT-F2-407: batch-level Customer + Scanners pickers. Customer
           picks the target Cognito pool (backend derives from the slug's
           cognito_pool.user_pool_id, falls back to legacy pool). Scanners
           multi-select is filtered to the picked customer. Per-row CSV
           values (mapped via the Customer / Scanners column dropdowns
           below) override these defaults. -->
      <!-- IT-F2-407: branded-SES status banner. When the picked customer
           doesn't have its own Cognito pool (or none picked → legacy),
           the invitees will receive Cognito's default temp-password email
           (not customer-branded). Warn up front so operator isn't
           surprised by the toast after import. -->
      <div *ngIf="!csvMapTargetPoolBrandedSes"
           class="mb-3 p-2 border border-amber-500/40 bg-amber-500/10 rounded text-xs text-amber-700 dark:text-amber-300 flex items-center gap-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>
          <strong>Legacy pool selected</strong> — invitees will receive Cognito&#39;s default temp-password email (not customer-branded). Pick a customer with its own pool if you want the branded magic-link invite.
        </span>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3 p-3 border border-gray-200 dark:border-[#434863] rounded bg-gray-50 dark:bg-app-black-100/40">
        <div>
          <label class="block mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Default Customer <span class="normal-case text-[10px]">(pool derived from this)</span></label>
          <select [(ngModel)]="csvMapCustomer" (ngModelChange)="csvMapOnCustomerChange()"
                  class="w-full bg-white dark:bg-app-black-500 border border-gray-300 dark:border-[#434863] text-gray-900 dark:text-white rounded px-2 py-1.5 text-sm"
                  [disabled]="csvMapImporting">
            <option value="">— none (legacy pool, no customer) —</option>
            <option *ngFor="let c of directoryCustomers" [value]="c._id">{{ c.name || c._id }} <span *ngIf="c.cognito_pool?.user_pool_id">(own pool)</span></option>
          </select>
        </div>
        <!-- IT-F2-407 (Mike 2026-09-18 c/7eb9ef8e): "we also need to select
             what role these bulk users will be". Per-row `Role` CSV column
             mapping still overrides; this is the batch default. -->
        <div>
          <label class="block mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Default Role</label>
          <select [(ngModel)]="csvMapRole"
                  class="w-full bg-white dark:bg-app-black-500 border border-gray-300 dark:border-[#434863] text-gray-900 dark:text-white rounded px-2 py-1.5 text-sm"
                  [disabled]="csvMapImporting">
            <option *ngIf="!roles || roles.length === 0" value="member">member</option>
            <option *ngFor="let r of roles" [value]="r">{{ r }}</option>
          </select>
        </div>
        <div>
          <!-- IT-F2-407 (Mike 2026-09-18 c/4f1f209a): visible checkboxes +
               selected-count. Previous chip UI hid the checkbox via sr-only
               and encoded selection with just a border color — Mike wanted
               the state readable at a glance. -->
          <label class="block mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Default Scanners
            <span class="normal-case text-[10px]">({{ csvMapScanners.length }} of {{ csvMapScannersForCustomer.length }} selected)</span>
          </label>
          <div *ngIf="!csvMapCustomer" class="text-xs text-gray-400 italic py-1">Pick a customer to see scanners.</div>
          <div *ngIf="csvMapCustomer && csvMapScannersForCustomer.length === 0" class="text-xs text-gray-400 italic py-1">No scanners configured for this customer.</div>
          <div *ngIf="csvMapCustomer && csvMapScannersForCustomer.length > 0" class="flex flex-col gap-1 max-h-24 overflow-y-auto">
            <label *ngFor="let s of csvMapScannersForCustomer"
                   class="inline-flex items-center gap-2 text-xs text-gray-900 dark:text-white cursor-pointer select-none py-0.5">
              <input type="checkbox"
                     class="rounded border-gray-300 dark:border-[#434863] focus:ring-app-teal-100"
                     [checked]="csvMapScanners.includes(s._id || s.Id)"
                     (change)="csvMapToggleScanner(s._id || s.Id)"
                     [disabled]="csvMapImporting">
              {{ s.Name || s._id || s.Id }}
            </label>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto border border-gray-300 dark:border-[#434863] rounded">
        <table class="text-xs font-mono min-w-full">
          <thead class="bg-gray-100 dark:bg-app-black-100">
            <tr>
              <!-- IT-F2-407 (Mike 2026-09-18 c/6c058572): status column for
                   the inline pre-flight "already exists in target pool" flag. -->
              <th class="p-2 text-left border-r border-gray-300 dark:border-[#434863] w-24">
                <div class="mb-1 text-gray-500 dark:text-gray-400 text-[10px] uppercase tracking-wide">Status</div>
              </th>
              <th *ngFor="let col of csvMapRawRows[0]; let i = index" class="p-2 text-left border-r border-gray-300 dark:border-[#434863]">
                <div class="mb-1 text-gray-500 dark:text-gray-400 text-[10px] uppercase tracking-wide">{{ csvMapColumnLabel(i) }}</div>
                <select [(ngModel)]="csvMapColumnMapping[i]" (ngModelChange)="csvMapOnColumnMappingChange()"
                        class="bg-white dark:bg-app-black-500 border border-gray-300 dark:border-[#434863] text-gray-900 dark:text-white rounded px-2 py-1 text-xs"
                        [class.border-app-teal-100]="csvMapColumnMapping[i] === 'Email'"
                        [disabled]="csvMapImporting">
                  <option *ngFor="let opt of CSV_FIELD_OPTIONS" [value]="opt">{{ opt }}</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of csvMapPreviewRows"
                class="border-t border-gray-200 dark:border-[#434863]"
                [class.bg-red-500]="csvMapRowStatus(csvMapRowEmail(row)) === 'no_change'"
                [class.bg-amber-500]="csvMapRowStatus(csvMapRowEmail(row)) === 'add_scanners'"
                [class.bg-opacity-10]="csvMapRowStatus(csvMapRowEmail(row)) === 'no_change' || csvMapRowStatus(csvMapRowEmail(row)) === 'add_scanners'">
              <td class="p-2 border-r border-gray-200 dark:border-[#434863] w-28">
                <!-- IT-F2-407 cid f9d728a2 — three-state badge: new / add-N / no-change. -->
                <span *ngIf="csvMapRowStatus(csvMapRowEmail(row)) === 'new'"
                      class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide bg-green-500/10 text-green-700 dark:text-green-300 border border-green-500/40"
                      title="New user — will be created on Import">
                  <i class="fa-solid fa-circle-check"></i>New
                </span>
                <span *ngIf="csvMapRowStatus(csvMapRowEmail(row)) === 'add_scanners'"
                      class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide bg-amber-500/15 text-amber-700 dark:text-amber-300 border border-amber-500/50"
                      [title]="'Already exists — Import will add ' + csvMapRowAddScannerCount(csvMapRowEmail(row)) + ' new entitlement(s) to this user (merges with their current custom:scanners / custom:customers)'">
                  <i class="fa-solid fa-plus"></i>+{{ csvMapRowAddScannerCount(csvMapRowEmail(row)) }} entitlement
                </span>
                <span *ngIf="csvMapRowStatus(csvMapRowEmail(row)) === 'no_change'"
                      class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide bg-red-500/20 text-red-700 dark:text-red-300 border border-red-500/40"
                      title="Already exists AND already carries every selected scanner + customer — nothing to add; will be skipped on Import">
                  <i class="fa-solid fa-triangle-exclamation"></i>No change
                </span>
              </td>
              <td *ngFor="let cell of row" class="p-2 text-gray-800 dark:text-gray-200 border-r border-gray-200 dark:border-[#434863] max-w-[220px] truncate">{{ cell || '&mdash;' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="!csvMapEmailColumnPicked" class="mt-3 text-xs text-red-500 dark:text-red-400">
        <i class="fa-solid fa-triangle-exclamation mr-1"></i>Pick a column and map it to <strong>Email</strong> to enable import.
      </div>
      <div *ngIf="csvMapImporting" class="mt-3">
        <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">
          Importing&hellip; {{ csvMapImportProgress }} / {{ csvMapImportTotal }}
        </div>
        <div class="h-2 bg-gray-200 dark:bg-app-black-100 rounded overflow-hidden">
          <div class="h-full bg-app-teal-100 transition-all" [style.width.%]="csvMapImportTotal ? (csvMapImportProgress / csvMapImportTotal * 100) : 0"></div>
        </div>
      </div>
    </div>
    <div class="px-4 py-3 border-t border-gray-200 dark:border-[#434863] flex items-center justify-end gap-2">
      <button type="button" (click)="csvMapCancel()" class="dark-btn-secondary text-xs px-3 py-1" [disabled]="csvMapImporting">Cancel</button>
      <button type="button" (click)="csvMapConfirmImport()" class="dark-btn-primary text-xs px-3 py-1 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="!csvMapEmailColumnPicked || csvMapImporting">
        <i *ngIf="csvMapImporting" class="fa-solid fa-circle-notch fa-spin mr-1"></i>
        {{ csvMapImporting ? 'Importing…' : 'Import' }}
      </button>
    </div>
  </div>
</div>

<!-- IT-F2-428 (Mike 2026-09-25): customer-scoped reconciliation report
     popup. Picks a single customer, filters this.data to that customer,
     downloads a CSV with exact fields for reconciliation. -->
<div *ngIf="show_reconciliation_modal"
     class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
     (click)="closeReconciliationModal()">
  <div class="bg-white dark:bg-app-black-500 rounded shadow-lg max-w-lg w-full border border-gray-200 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="px-4 py-3 border-b border-gray-200 dark:border-[#434863] flex items-center justify-between">
      <div class="text-sm font-semibold text-gray-800 dark:text-gray-100">
        <i class="fa-solid fa-user-check mr-1 dark:text-sky-400"></i> Customer Reconciliation Report
      </div>
      <button class="dark-btn text-xs px-2 py-1" (click)="closeReconciliationModal()">
        <i class="fa-solid fa-xmark"></i> Close
      </button>
    </div>
    <div class="px-4 py-3 text-xs text-gray-700 dark:text-gray-200 space-y-3">
      <p>
        Per-customer user snapshot the customer can reconcile against their purchase records.
        Includes only users belonging to the selected customer &mdash; no cross-customer data.
      </p>
      <p class="text-gray-500 dark:text-gray-400">
        Columns: <b>Email</b>, <b>Name</b>, <b>Status</b> (Active / Force Change Password / Disabled / Unconfirmed),
        <b>Scanners</b>, <b>Claims</b>, <b>Created</b>, <b>Last Login</b>, <b>Last Updated</b> (proxy for deactivation timestamp when status = Disabled).
        Dates render in ET.
      </p>
      <label class="flex flex-col gap-1">
        <span class="text-gray-600 dark:text-gray-300">Customer:</span>
        <select [(ngModel)]="reconciliation_customer"
                class="bg-gray-50 dark:bg-app-blue-100/20 border border-gray-300 dark:border-[#434863] rounded px-2 py-1">
          <option value="">-- pick a customer --</option>
          <option *ngFor="let c of customers" [value]="c?.slug || c">{{ c?.slug || c }}</option>
        </select>
      </label>
    </div>
    <div class="px-4 py-3 border-t border-gray-200 dark:border-[#434863] flex justify-end gap-2">
      <button type="button" class="dark-btn text-xs px-3 py-1" (click)="closeReconciliationModal()">Cancel</button>
      <button type="button" class="dark-btn text-xs px-3 py-1 bg-blue-600 text-white disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="!reconciliation_customer"
              (click)="exportReconciliationCsv()">
        <i class="fa-solid fa-file-arrow-down mr-1"></i> Download CSV
      </button>
    </div>
  </div>
</div>
